import { type MarketplaceId } from "@nova-ai/shared"

import { cn } from "../../lib/utils"
import { CountryFlag } from "./country-flag"
import { MarketplaceLogo } from "./marketplace-logo"
import { marketplaceMeta } from "./marketplace-meta"

type MarketplaceMarkProps = {
  marketplace: MarketplaceId
  className?: string
  showCountryCode?: boolean
}

/** The brand logo with a country flag or code pinned to its corner. */
export function MarketplaceMark({
  marketplace,
  className,
  showCountryCode = false,
}: MarketplaceMarkProps) {
  const { country } = marketplaceMeta(marketplace)
  return (
    <span className={cn("relative inline-flex size-5 shrink-0", className)}>
      <MarketplaceLogo marketplace={marketplace} className="size-full rounded-lg" />

      {showCountryCode ? (
        <span className="absolute -right-1 -bottom-1 rounded-[4px] border border-border bg-card px-[3px] text-[8px] leading-3 font-semibold text-foreground">
          {country.toUpperCase()}
        </span>
      ) : (
        <CountryFlag
          country={country}
          className="absolute -bottom-1 -right-1 inline-flex items-center justify-center rounded-[3px] bg-background px-px text-[10px] leading-none ring-1 ring-border/60"
        />
      )}
    </span>
  )
}
